import React from "react";
import { useState, useEffect } from "react";
import TravelItineraryTopButtons from "../../components/TravelItineraryTopButtons/TravelItineraryTopButtons";
import CarryMyPet from "../../images/cmp_logo_minidrawer.svg";
import Plane from "../../images/Air.svg";
import plane from "../../images/orderList-plane.svg";
import map from "../../images/World Map.svg";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import CircleIcon from "@mui/icons-material/Circle";
import "./TestItineraryPDF.css";
import DesktopNavbar from "../../components/Navbar/Desktop/DesktopNavbar";
import DesktopMiniDrawer from "../../components/MiniDrawer/DesktopMiniDrawer/DesktopMiniDrawer";
import MobileNavbar from "../../components/Navbar/Mobile/MobileNavbar";
import MobileMiniDrawer from "../../components/MiniDrawer/MobileMiniDrawer/MobileMiniDrawer";


function TestItinerary() {
  const [isMiniDrawerVisible, setIsMiniDrawerVisible] = useState(false);
  const [activeForm, setActiveForm] = useState({
    customerDetails: true,
    relocationDetails: false,
    petDetails: false,
    preview: false,
    documentation: false,
  });
console.log("hello");
  useEffect(() => {
    window.scrollTo(0, 0);

    
  }, []);

  const toggleMiniDrawer = () => {
    setIsMiniDrawerVisible(!isMiniDrawerVisible);
  };

  return (
    <>
      <div style={{ height: "100vh" }} className="orderSummary-mobile-hide p-0">
        <div className="row p-0">
          <div className="col-12 p-0">
            <div
              style={{ backgroundColor: "white" }}
              className="itinerary-main-content-div container-fluid p-0 mb-5"
            >
              <div
                style={{ position: "relative", zIndex: "1", height: "45px" }}
                className="px-1 row top-button-main d-flex justify-content-between align-items-center"
              >
                <div className="col-2">
                  <img
                    style={{ width: "80px" }}
                    src={CarryMyPet}
                    className="img-fluid"
                  />
                </div>
                <div className="col-9 text-end"></div>
                <div
                  style={{
                    height: "102px",
                    width: "104px",
                    padding: "14px 8px 8px 11px",
                    position: "absolute",
                    top: "0px",
                    right: "30px",
                    backgroundColor: "white",
                    boxShadow:
                      "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                  }}
                  className="col-1 text-center "
                >
                  <img
                    style={{ width: "51px", height: "69px" }}
                    src={Plane}
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="container-fluid px-0 mt-4">
                <div
                  style={{ borderBottom: "2px solid #5B489D" }}
                  className="mt-4"
                >
                  <div className="order-main-list-left px-0 mt-4">
                    <div className=" w-100 d-flex flex-column  align-items-start travel-itinerary-main-heading order-main-list-left-top">
                      <h4
                        className="mt-2"
                        style={{
                          margin: "0px",
                          color: "#3D3D3D",
                          fontSize: "29px",
                        }}
                      >
                        TRAVEL{" "}
                        <span style={{ color: "#5B489D" }}>ITINERARY</span>
                      </h4>
                      <span
                        style={{
                          color: "#474747",
                          fontSize: "12px",
                          borderBottom: "4px solid #5B489D",
                          fontWeight: "bold",
                        }}
                      >
                        ONE LIVE CAT{" "}
                        <span style={{ fontWeight: "400" }}>
                          (DOOR-TO-DOOR)
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid px-0">
                <div style={{ position: "relative" }} className="row">
                  <div
                    style={{ position: "absolute", top: "0px" }}
                    className="col-12 container p-0"
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <img className="img-fluid" src={map} />
                    </div>
                  </div>
                </div>
                <div className="row py-0 px-0">
                  <div className="col-12 p-0 mt-2 text-end">
                    <h6
                      style={{
                        color: "#FF0000",
                        fontSize: "12px",
                        margin: "0px",
                      }}
                    >
                      JOB ID : <span style={{ color: "#474747" }}>53349</span>
                    </h6>
                  </div>
                </div>
                <div className="row py-1 px-0">
                  <div className="itinerary-world-content px-2 d-flex flex-column align-items-center">
                    <div
                      style={{ paddingBottom: "0px" }}
                      className="row w-100 flex justify-content-between align-items-center mt-4 px-4"
                    >
                      <div className="col-3 text-center">
                        <h4
                          style={{
                            margin: "0px",
                            color: "#5B489D",
                            fontWeight: "bold",
                            fontSize: "37px",
                          }}
                        >
                          DEL
                        </h4>
                        <h5 style={{ fontSize: "12px" }}>New Delhi</h5>
                        <h6
                          style={{
                            color: "#474747",
                            fontWeight: "bold",
                            fontSize: "17px",
                            margin: "0px",
                          }}
                        >
                          10 JULY 2024
                        </h6>
                        <h5
                          style={{
                            color: "#6A6A6A",
                            fontSize: "15px",
                            marginTop: "3px",
                          }}
                        >
                          WED | 17:20
                        </h5>
                      </div>
                      <div className="d-flex justify-content-between align-items-center col-6">
                        <CircleIcon
                          style={{
                            fontSize: "20px",
                            marginRight: "12px",
                            color: "#6A6A6A",
                          }}
                        />
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{
                            position: "relative",
                            border: "none",
                            borderTop: "2px dotted #474747",
                            width: "100%",
                          }}
                        >
                          <hr className="dotted-hr" />
                          <img
                            src={plane}
                            className="img-fluid"
                            style={{
                              position: "absolute",
                              left: "50%",
                              top: "-13px",
                              width: "38px",
                            }}
                          />
                        </div>
                        <ArrowRightIcon
                          style={{ fontSize: "40px", color: "#6A6A6A" }}
                        />
                      </div>

                      <div className="col-3  text-center">
                        <h4
                          style={{
                            margin: "0px",
                            color: "#5B489D",
                            fontWeight: "bold",
                            fontSize: "37px",
                          }}
                        >
                          BLR
                        </h4>
                        <h5 style={{ fontSize: "12px" }}>Bengaluru</h5>
                        <h6
                          style={{
                            color: "#474747",
                            fontWeight: "bold",
                            fontSize: "17px",
                            margin: "0px",
                          }}
                        >
                          10 JULY 2024
                        </h6>
                        <h5
                          style={{
                            color: "#6A6A6A",
                            fontSize: "15px",
                            marginTop: "3px",
                          }}
                        >
                          WED | 17:20
                        </h5>
                      </div>
                    </div>
                    <div className="container">
                      <hr className="px-4 py-0 m-3" style={{ width: "100%" }} />
                    </div>
                    <div className="py-2 row w-100 flex justify-content-between align-items-center">
                      <div className="col-3 text-center">
                        <h5
                          className="m-0"
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        >
                          AIRLINE
                        </h5>
                        <h4
                          style={{
                            color: "#474747",
                            fontWeight: "bold",
                            fontSize: "17px",
                          }}
                        >
                          AIR INDIA
                        </h4>
                      </div>
                      <div className="col-6 text-center">
                        <h5
                          className="m-0"
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        >
                          FLIGHT
                        </h5>
                        <h4
                          style={{
                            color: "#474747",
                            fontWeight: "bold",
                            fontSize: "17px",
                          }}
                        >
                          AI 807
                        </h4>
                      </div>

                      <div className="col-3  text-center">
                        <h5
                          className="m-0"
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        >
                          DELIVERY TYPE
                        </h5>
                        <h4
                          style={{
                            color: "#474747",
                            fontWeight: "bold",
                            fontSize: "17px",
                          }}
                        >
                          DOOR-TO-DOOR
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="container-fluid px-0 itinerary-pet-form"
                style={{ padding: "14px 28px 14px 28px" }}
              >
                <div className="px-0 py-2">
                  <h4
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      borderBottom: "1px solid #D9D9D9",
                    }}
                    className="mt-0 px-0 relocation-heading2"
                  >
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        padding: "10px 18px 10px 18px",
                        borderBottom: "4px solid #5B489D",
                        padding: "0px",
                        color: "#474747",
                      }}
                      className="text-start"
                    >
                      PET{" "}
                    </span>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        padding: "10px 18px 10px 18px",
                        borderBottom: "4px solid #5B489D",
                        padding: "0px",
                        color: "#5B489D",
                      }}
                      className="text-start"
                    >
                      DETAILS{" "}
                    </span>
                  </h4>
                </div>
                <div
                  className="travel-itinerary-details-main-info mt-0 px-0 py-0"
                  style={{ paddingBottom: "0px" }}
                >
                  <div className=" mt-0 form-row  align-items-start">
                    <div className="col-3">
                      <h3
                        style={{
                          color: "#6a6a6a",
                          marginTop: "4px",
                          marginBottom: "5px",
                        }}
                      >
                        Pet Type
                      </h3>
                      <h4
                        style={{
                          border: "none",
                          width: "100%",
                          color: "black",
                          padding: "0px",
                        }}
                      >
                        Indie Ginger Cat
                      </h4>
                    </div>

                    <div className="col-3">
                      <h3
                        style={{
                          color: "#6a6a6a",
                          marginTop: "4px",
                          marginBottom: "5px",
                        }}
                      >
                        Breed
                      </h3>
                      <h4
                        style={{
                          border: "none",
                          width: "100%",
                          color: "black",
                          padding: "0px",
                        }}
                      >
                        Indie Ginger Cat
                      </h4>
                    </div>

                    <div className="col-3">
                      <h3
                        style={{
                          color: "#6a6a6a",
                          marginTop: "4px",
                          marginBottom: "5px",
                        }}
                      >
                        Name of Pet
                      </h3>
                      <h4
                        style={{
                          border: "none",
                          width: "100%",
                          color: "black",
                          padding: "0px",
                        }}
                      >
                        LOLA
                      </h4>
                    </div>

                    <div className="col-3">
                      <h3
                        style={{
                          color: "#6a6a6a",
                          marginTop: "4px",
                          marginBottom: "5px",
                        }}
                      >
                        Age
                      </h3>
                      <h4
                        style={{
                          border: "none",
                          width: "100%",
                          color: "black",
                          padding: "0px",
                        }}
                      >
                        1 year and 10 months
                      </h4>
                    </div>
                  </div>

                  <div className="form-row mt-0 row align-items-center">
                    <div className="col-3">
                      <h3
                        style={{
                          color: "#6a6a6a",
                          marginTop: "8px",
                          marginBottom: "5px",
                        }}
                      >
                        Cage Size
                      </h3>
                      <h4
                        style={{
                          border: "none",
                          width: "100%",
                          color: "black",
                          padding: "0px",
                        }}
                      >
                        24 Inches
                      </h4>
                    </div>

                    <div className="col-3">
                      <h3
                        style={{
                          color: "#6a6a6a",
                          marginTop: "8px",
                          marginBottom: "5px",
                        }}
                      >
                        Cage Status
                      </h3>
                      <h4
                        style={{
                          border: "none",
                          width: "100%",
                          color: "black",
                          padding: "0px",
                        }}
                      >
                        Complementary
                      </h4>
                    </div>

                    <div className="col-3">
                      <h3
                        style={{
                          color: "#6a6a6a",
                          marginTop: "8px",
                          marginBottom: "5px",
                        }}
                      >
                        Date of Pet Travel
                      </h3>
                      <h4
                        style={{
                          border: "none",
                          width: "100%",
                          color: "black",
                          padding: "0px",
                        }}
                      >
                        10 Jul 2024 | Wednesday{" "}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-0 m-0">
                <div className="px-0 py-0">
                  <h4
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      borderBottom: "1px solid #D9D9D9",
                    }}
                    className="mt-0 px-0  relocation-heading2"
                  >
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        padding: "10px 18px 10px 18px",
                        borderBottom: "4px solid #5B489D",
                        padding: "0px",
                        color: "#474747",
                      }}
                      className="text-start"
                    >
                      TRAVEL{" "}
                    </span>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        padding: "10px 18px 10px 18px",
                        borderBottom: "4px solid #5B489D",
                        padding: "0px",
                        color: "#5B489D",
                      }}
                      className="text-start"
                    >
                      DETAILS{" "}
                    </span>
                  </h4>
                </div>
                <div className="row px-0 py-2 mb-5">
                  <div
                    className="col-6 "
                    style={{ padding: "1px 4px 4px 0px" }}
                  >
                    <h4
                      className="heading text-center"
                      style={{
                        fontSize: "12px",
                        padding: "6px",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                      }}
                    >
                      Pick-up Details
                    </h4>
                    <div
                      style={{ border: "1px solid rgb(229 225 225)" }}
                      className="col-lg-12 col-md-12 itinerary-main-list-right"
                    >
                      <div
                        style={{ border: "none" }}
                        className="row itinerary-main-list-right-content"
                      >
                        <div class="container-fluid p-0  text-start">
                          <div class="row p-2">
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Pick-up Contact Details{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              {" "}
                              Mr. Mukul Sharma, +91 898 808 7890, +91 897 789
                              7890
                            </span>
                          </div>
                        </div>
                        <div class="container-fluid p-0  text-start">
                          <div
                            style={{ backgroundColor: "#F6F3FF" }}
                            class="row p-2"
                          >
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Pick-up Address
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              {" "}
                              208, DLT Residency Apartment, Crossroad,
                              Bengalurur -560066
                            </span>
                          </div>
                        </div>{" "}
                        <div class="container-fluid p-0  text-start">
                          <div class="row p-2">
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Pick-up Time (Tentative)
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              {" "}
                              Tentatively pet will be handover by 00:00 - 01:00
                              HRS of 11th July 2024, Thursday
                            </span>
                          </div>
                        </div>{" "}
                        <div class="container-fluid p-0  text-start">
                          <div
                            style={{ backgroundColor: "#F6F3FF" }}
                            class="row p-2"
                          >
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Estimate Departure
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              {" "}
                              20:10 HRS Bengaluru(BLR)
                            </span>
                          </div>
                        </div>{" "}
                        <div class="container-fluid p-0  text-start">
                          <div class="row p-2">
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Executive Contact (Origin){" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              Mr. Guruprasad ; +91-8147674625
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-6 "
                    style={{ padding: "1px 0px 4px 0px" }}
                  >
                    <h4
                      className="heading text-center"
                      style={{
                        fontSize: "12px",
                        padding: "6px",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                      }}
                    >
                      Drop Details
                    </h4>
                    <div
                      style={{ border: "1px solid rgb(229 225 225)" }}
                      className="col-lg-12 col-md-12 itinerary-main-list-right"
                    >
                      <div
                        style={{ border: "none" }}
                        className="row itinerary-main-list-right-content"
                      >
                        <div class="container-fluid p-0  text-start">
                          <div class="row p-2">
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Drop Contact Details{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              {" "}
                              Mr. Mukul Sharma, +91 898 808 7890, +91 897 789
                              7890
                            </span>
                          </div>
                        </div>
                        <div class="container-fluid p-0  text-start">
                          <div
                            style={{ backgroundColor: "#F6F3FF" }}
                            class="row p-2"
                          >
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Drop Address
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              {" "}
                              208, DLT Residency Apartment, Crossroad,
                              Bengalurur -560066
                            </span>
                          </div>
                        </div>{" "}
                        <div class="container-fluid p-0  text-start">
                          <div class="row p-2">
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Handover Time (Tentative)
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              {" "}
                              Tentatively pet will be handover by 00:00 - 01:00
                              HRS of 11th July 2024, Thursday
                            </span>
                          </div>
                        </div>{" "}
                        <div class="container-fluid p-0  text-start">
                          <div
                            style={{ backgroundColor: "#F6F3FF" }}
                            class="row p-2"
                          >
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Estimate Arrival
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              {" "}
                              20:10 HRS Bengaluru(BLR)
                            </span>
                          </div>
                        </div>{" "}
                        <div class="container-fluid p-0  text-start">
                          <div class="row p-2">
                            <span
                              style={{ color: "#6a6a6a" }}
                              class="col-4 py-0 px-0"
                            >
                              Executive Contact (Destination){" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-1 p-0"
                            >
                              :{" "}
                            </span>
                            <span
                              style={{ fontWeight: "500", color: "#474747" }}
                              class="col-7 p-0"
                            >
                              {" "}
                              Mr. Guruprasad ; +91-8147674625
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TestItinerary;
